import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const InteractionsHandIcon: ComponentWithAs<'svg', IIconProps> = (
  props,
) => (
  <Icon
    data-testid="interactions-reels-icon"
    boxSize={6}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M5.3335 8.66667V3C5.3335 2.44772 5.78121 2 6.3335 2C6.88578 2 7.3335 2.44772 7.3335 3V8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.3335 7.66671V6.33337C7.3335 5.78109 7.78121 5.33337 8.3335 5.33337C8.88578 5.33337 9.3335 5.78109 9.3335 6.33337V8.00004"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.3335 7C9.3335 6.44772 9.78121 6 10.3335 6C10.8858 6 11.3335 6.44772 11.3335 7V8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3341 7.66663C11.3341 7.11434 11.7818 6.66663 12.3341 6.66663C12.8864 6.66663 13.3341 7.11434 13.3341 7.66663V10.6666C13.3341 12.8758 11.5432 14.6666 9.33409 14.6666H8.00076H8.13943C6.79378 14.6669 5.5382 13.9905 4.79809 12.8666L4.66743 12.6666C4.45943 12.3473 3.72943 11.0746 2.47676 8.84796C2.21123 8.37599 2.36964 7.77842 2.83409 7.49996C3.32361 7.20624 3.95019 7.28319 4.35409 7.68663L5.33409 8.66663"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33317 2.00004L2.6665 1.33337"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66667 4.66671H2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.3335 2.00004L10.0002 1.33337"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 3.99996H10.6667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
